export default __webpack_public_path__ + "static/SectionTwo_01_02@2x-44294b055856876cdb0964ad801ad253.png";